import React from "react";
import { useLang, SUPPORTED } from "../lib/i18n";

/**
 * Language toggle for the customer Navbar.
 * Shows DA / EN pill switch with persistence via i18n provider.
 */
export default function LanguageToggle({ className = "", light = false }) {
  const { lang, setLang } = useLang();
  return (
    <div
      className={`inline-flex items-center text-[10px] font-bold tracking-widest uppercase border ${light ? "border-white/30" : "border-brand"} ${className}`}
      data-testid="lang-toggle"
    >
      {SUPPORTED.map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={`lang-${code}`}
          aria-pressed={lang === code}
          className={`px-2 py-1 transition ${
            lang === code
              ? light
                ? "bg-white text-brand-dark"
                : "bg-brand-dark text-white"
              : light
              ? "text-white/70 hover:text-white"
              : "text-brand-text2 hover:text-brand-dark"
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
}
